import Villa from './Villa';

export default Villa;